<img class="navbar-logo" src="../../../assets/inspire-white-magenta.svg"/>
